/* eslint-disable max-len */
import {
  SaveCrossSellingReferenceRequest,
  CrossSellingMainReference,
  CrossSellingVehicle,
  CrossSellingReference,
} from '@1po/1po-bff-fe-spec/generated/backoffice/cross_selling/request/SaveCrossSellingReferenceRequest';
import { ReferenceStock } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/model/ReferenceStock';
import { VehicleDetail } from '@1po/1po-bff-fe-spec/generated/common/vehicle/VehicleDetail';
import { DHReferenceLocal, ReferencePriceType } from 'domains/references';

export const mapSaveCrossSellingReferenceRequest = (
  vehicleDetail: VehicleDetail | undefined,
  mainReference: DHReferenceLocal,
  crossSellReference: DHReferenceLocal,
  priceData?: ReferencePriceType,
  stockData?: ReferenceStock,
): SaveCrossSellingReferenceRequest => {
  const vehicle: CrossSellingVehicle = {
    brand: vehicleDetail?.vehicleBrand ?? '',
    model: vehicleDetail?.model ?? '',
    vin: vehicleDetail?.vin ?? '',
    vrn: vehicleDetail?.vrn ?? '',
  };
  const reference: CrossSellingMainReference = {
    referenceNumber: mainReference.referenceNumber ?? '',
    name: mainReference.name ?? '',
    referenceType: mainReference.type,
    familyCode: mainReference.familyCode ?? '',
    catalogSource: mainReference.source === 'dh' ? 'DATAHUB' : 'IAM',
    segmentMarketing: (mainReference.source === 'dh' ? mainReference.segmentMarketing : '') ?? '',
  };
  const crossSellingReference: CrossSellingReference = {
    referenceNumber: crossSellReference.referenceNumber ?? '',
    name: crossSellReference.name ?? '',
    priceDetail: {
      garagePriceVatIncluded: priceData?.garageView?.vatIncludedPrice ?? '0',
      garagePriceVatExcluded: priceData?.garageView?.vatExcludedPrice ?? '0',
      clientPriceVatIncluded: priceData?.garageView?.vatExcludedPriceUrgent ?? '0',
      clientPriceVatExcluded: priceData?.garageView?.vatIncludedPriceUrgent ?? '0',
    },
    stockDetail: {
      warehouses: stockData?.warehouses ?? [],
    },
    quantityRatio: 1,
    brand: crossSellReference.brand ?? 'OTHER',
    referenceType: crossSellReference.type,
    familyCode: crossSellReference.familyCode ?? '',
    segmentMarketing: (crossSellReference.source === 'dh' ? crossSellReference.segmentMarketing : '') ?? '',
  };
  return {
    vehicle,
    reference,
    crossSellingReference,
  };
};
